import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { orderModel } from '@features/my-gousto-page/src/models/orderModel'

import userActions, { userFetchReferralOffer } from 'actions/user'
import { getBasketOrderDetails } from 'selectors/basket'
import { isOrderConfirmationPageLoading } from 'selectors/orderConfirmation'
import { locationQuery } from 'selectors/routing'
import { getAgeVerified } from 'selectors/user'

import { OrderConfirmation } from './OrderConfirmation'
import { getHeaderDetails, isFiveForFour } from './helper'

const mapStateToProps = (state) => {
  const locationQueryParam = locationQuery(state)
  const order = getBasketOrderDetails(state)
  const showMultipleBoxesDeliveryMessage = !!order && isFiveForFour(order)
  const isLoading = !order || isOrderConfirmationPageLoading(state)
  const model = orderModel()
  const canEditOrder = !!order && model.isOrderEditable(order.toJS())
  const orderId = !!order && order.get('id')
  // Read orderType off the loaded order, not user.orders: a freshly-created order
  // isn't in user.orders until a reload, so that lookup is stale on the checkout redirect.
  const isTransactional = !!order && order.get('orderType') === 'transactional'
  const headerDetails = !!order && getHeaderDetails(order, isTransactional)
  const showHeader = !!(locationQueryParam && locationQueryParam.order_action) && !!headerDetails

  return {
    ageVerified: getAgeVerified(state),
    headerDetails,
    isLoading,
    showHeader,
    showMultipleBoxesDeliveryMessage,
    canEditOrder,
    orderId,
    isTransactional,
  }
}

const mapDispatchToProps = {
  userFetchReferralOffer,
  userVerifyAge: userActions.userVerifyAge,
  userLoadData: userActions.userLoadData,
}

const OrderConfirmationContainer = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OrderConfirmation),
)

export { OrderConfirmationContainer }
